import React, { useState, useEffect } from 'react';
import { FaCode, FaDatabase, FaCloud, FaRobot } from 'react-icons/fa';

const Mercury = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const skillCategories = [
    {
      icon: <FaCode />,
      title: 'Frontend',
      items: ['React.js', 'HTML/CSS', 'JavaScript'],
    },
    {
      icon: <FaDatabase />,
      title: 'Backend',
      items: ['Node.js', 'Express', 'Firebase', 'MongoDB'],
    },
    {
      icon: <FaCloud />,
      title: 'Cloud',
      items: ['AWS'],
    },
    {
      icon: <FaRobot />,
      title: 'Other',
      items: ['NumPy', 'Pandas', 'Git', 'REST APIs'],
    },
  ];

  return (
    <section style={styles.container}>
      <div style={styles.wrapper}>
        <h2 style={styles.heading}>💻 Technical Skills</h2>
        <p style={styles.subtext}>All the tools in my toolkit!</p>

        <div style={styles.flexRow}>
          {/* LEFT: Skill Cards */}
          <ul style={styles.grid}>
            {skillCategories.map((cat, index) => (
              <li
                key={index}
                style={{
                  ...styles.card,
                  animation: `fadeInUp 0.6s ease ${index * 0.2}s both`,
                  backgroundColor: hoveredIndex === index ? 'rgba(22, 30, 50, 0.85)' : 'rgba(15, 25, 40, 0.5)',
                  boxShadow:
                    '0 0 35px rgba(0, 191, 255, 0.7), inset 0 0 50px rgba(31, 143, 255, 0.3), 0 0 15px rgba(153, 224, 255, 0.3)',
                  border: '1px solid rgba(0, 191, 255, 0.7)',
                  transform: hoveredIndex === index ? 'translateY(-6px)' : 'none',
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div style={styles.cardHeader}>
                  <span style={styles.icon}>{cat.icon}</span>
                  <strong style={styles.title}>{cat.title}</strong>
                </div>
                <ul style={styles.skills}>
                  {cat.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>

          {/* RIGHT: Text Introduction */}
          <div style={styles.introText}>
            <p>
              I’m a passionate Software Development Engineer with a knack for building intuitive, responsive digital
              experiences. With a solid foundation in full-stack development and a specialization in frontend, I love
              crafting clean interfaces and solving complex problems. My toolkit reflects both curiosity and consistency —
              built over time through projects, mentorship, and a love for technology.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  container: {
    padding: '30px 20px',
    display: 'flex',
    justifyContent: 'center',
    background: 'transparent',
  },
  wrapper: {
    width: '100%',
    maxWidth: '1200px',
    color: '#dde9ff',
  },
  heading: {
    fontSize: '2.5rem',
    marginBottom: '40px',
    color: '#aac8ff',
    textAlign: 'center',
    fontWeight: 790,
  },
  subtext: {
    fontSize: '1rem',
    textAlign: 'center',
    maxWidth: '600px',
    margin: '0 auto 40px auto',
    lineHeight: '1.6',
    color: '#aabbddee',
  },
  flexRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '60px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '30px',
    listStyle: 'none',
    padding: 0,
    flex: '1 1 50%',
    minWidth: '280px',
  },
  card: {
    backgroundColor: '#0a0a0a',
    borderRadius: '15px',
    alignItems: 'center',
    width: '250px',
    padding: '25px',
    boxShadow:
      'inset 0 0 30px rgba(0, 191, 255), 0 0 25px rgba(0, 191, 255, 0.4), 0 0 10px rgba(31, 143, 255, 0.2)',
    border: '1px solid rgba(0, 191, 255, 0.5)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease',
    color: '#e6f3ff',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '12px',
  },
  icon: {
    fontSize: '1.8rem',
    color: '#00bfff',
    textShadow: '0 0 6px rgba(0, 191, 255, 0.6)',
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 600,
    color: '#aac8ff',
  },
  skills: {
    paddingLeft: '20px',
    fontSize: '0.95rem',
    lineHeight: '1.6',
    color: '#c0d8ffcc',
    listStyle: 'disc',
  },
  introText: {
    flex: '1 1 40%',
    maxWidth: '450px',
    fontSize: '1rem',
    lineHeight: '1.8',
    color: '#c9dfff',
    alignSelf: 'center'
  },
};

export default Mercury;
